import script from "./HomeDestaques.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDestaques.vue?vue&type=script&setup=true&lang=js"

import "./HomeDestaques.vue?vue&type=style&index=0&id=3bd42a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bd42a54"]])

export default __exports__